module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contentBlock"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "title-text"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('el-container', [_c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-position": "right",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "通知内容：",
      "prop": "content"
    }
  }, [_c('el-input', {
    staticStyle: {
      "min-width": "600px"
    },
    attrs: {
      "type": "textarea",
      "maxlength": "96",
      "rows": "5",
      "cols": "20",
      "autoFocus": "",
      "placeholder": "不超过96个字....."
    },
    model: {
      value: (_vm.ruleForm.content),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "content", $$v)
      },
      expression: "ruleForm.content"
    }
  })], 1), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图片描述："
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "list-type": "picture-card",
      "http-request": _vm.handleLicenseImgFileB,
      "show-file-list": true,
      "file-list": _vm.fileList,
      "limit": 3,
      "auto-upload": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-remove": _vm.handleRemove,
      "on-preview": _vm.handlePictureCardPreview
    }
  }, [_c('i', {
    staticClass: "el-icon-plus",
    attrs: {
      "slot": "default"
    },
    slot: "default"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "处理人："
    }
  }, [_c('el-select', {
    staticStyle: {
      "min-width": "600px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.operator),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "operator", $$v)
      },
      expression: "ruleForm.operator"
    }
  }, _vm._l((_vm.operatorArr), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.label,
        "value": item.id
      }
    })
  }), 1)], 1), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/announcement"
    }
  }, [_c('el-button', {
    staticClass: "cancel"
  }, [_vm._v("取消")])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "submit",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("提交")])], 1), _c('br')], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44171231"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/personnel/addEditComponent.vue
// module id = 1235
// module chunks = 2